import { render, staticRenderFns } from "./charge-success.vue?vue&type=template&id=fbff4c0c&scoped=true&"
import script from "./charge-success.vue?vue&type=script&lang=js&"
export * from "./charge-success.vue?vue&type=script&lang=js&"
import style0 from "./charge-success.vue?vue&type=style&index=0&id=fbff4c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff4c0c",
  null
  
)

export default component.exports